import Item from "../../items/Item";
import ItemIniter from "../../items/ItemIniter";
import ItemProviders from "../../items/ItemProviders";
import PageCommon from "../../PageCommon";
import SpriteSheetSlicer from "../SpriteSheetSlicer";
import ToolPanel from "./ToolPanel";

export default class Tool {
	constructor() {

	}
	init() {

		PageCommon.showPreloader(false);
		let mc = jQuery("#template-tool").clone();
		mc.attr("id", "tool" + Tool.ENUM++);

		jQuery("body").append(mc);

		this.mc = jQuery(".js-content", mc);
		this.main = mc;

		this.loadAtlas("./assets/atlas.json");

	}


	loadAtlas(file) {
		jQuery.getJSON(file, null, this.atlasLoaded.bind(this));


	}
	atlasLoaded(data) {
		this.data = data;
		//console.log(data)
		let a = data.sheets.files;
		for (let x = 0; x <= a.length; x++) {
			
			let but = jQuery("#template-but").clone();
			but.attr("id", "but" + Tool.ENUM++);
			let name
			if (x === a.length) {
				name = "RESULT";
			} else {
				name = a[x].split(".")[0];
			}
			but.text(name);
			but.addClass("js-counter-" + name);
			jQuery(".js-menu", this.main).append(but);
			if (x === a.length) {
				but.on("click", this.showResult.bind(this, but));
			} else {
				but.on("click", this.selectImage.bind(this, but, a[x]));
			}
		}

		for (let x = 0; x < data.assets.length; x++) {
			data.assets[x] = this.update(data.assets[x]);
		}

		this.countItems();
		if (this.data.assets.length > 0) {
			let sheet = this.data.assets[this.data.assets.length - 1]
			jQuery(".js-counter-" + sheet.sheet).trigger("click");
		}

		//this.loadImage();
	}

	selectImage(but, name) {
		jQuery(".but-menu-selected").removeClass("but-menu-selected");
		but.addClass("but-menu-selected");
		this.loadImage(this.data.sheets.path + name);
		this.currentFile = name;

		if (this.panelCompare) {
			this.panelCompare.remove();
			this.panelCompare = null;
		}
		if (this.panel) {
			this.panel.remove();
			this.panel = null;
		}


	}

	loadImage(file) {
		this.mc.html("");
		this.image = new Image();
		this.image.onload = this.imageLoaded.bind(this);
		this.image.src = file;
	}
	imageLoaded() {
		this.createGrid();
		this.mc.append(jQuery(this.image));

	}


	createGrid() {
		let rows = Math.floor(this.image.height / Tool.CELL_HEIGHT);
		let cols = Math.floor(this.image.width / Tool.CELL_WIDTH);
		jQuery(this.image).addClass("imagetool")
		jQuery(this.image).css({
			width: this.image.width / 4,
			height: this.image.height / 4,
		})
		for (let row = 0; row < rows; row++) {
			for (let col = 0; col < cols; col++) {
				let cell = jQuery("#template-cell-tool").clone();
				cell.attr("id", "celtoo" + Tool.ENUM++);
				cell.attr("data-ref", row + "|" + col);
				cell.css({
					top: Tool.CELL_HEIGHT / 4 * row,
					left: Tool.CELL_WIDTH / 4 * col,
					width: Tool.CELL_WIDTH / 4,
					height: Tool.CELL_HEIGHT / 4,
				});
				this.mc.append(cell);
				cell.on("click", this.clickedCell.bind(this, cell, row, col));
				//cell.on("mouseenter", this.mouseOver.bind(this, cell, row, col));
				//cell.on("mouseleave", this.mouseOut.bind(this, cell, row, col));

				this.hilightCell(cell);
			}
		}
	}

	clickedCell(cell, row, col) {
		jQuery(".selected").removeClass("selected");
		if (this.panel) {
			this.panel.remove();
			this.panel = null;
		}
		this.initPanel(cell, row, col)
	}

	initPanel(cell, row, col) {
		this.panel = jQuery("#template-paneldata").clone();
		this.panel.attr("id", "pandat" + Tool.ENUM++);
		this.panel.css("left", jQuery(this.image).width() + 10);
		this.mc.append(this.panel);
		cell.addClass("selected");
		let det = this.getDetailsOf(this.getItemId(row, col), row, col);
		this.tp = new ToolPanel(cell, this.panel, row, col, det.item, det.newItem, this.panelEventsHandler.bind(this));
		this.tp.init();
	}

	panelEventsHandler(e) {
		if (e.type === ToolPanel.EVENT_CHANGED) {
			this.addOrUpdateItem(e.data.item, e.data.data);
			this.hilightCell(e.data.data.cell);
		}
		if (e.type === ToolPanel.EVENT_DELETE) {
			this.deleteItem(e.data.item, e.data.data);
			this.hilightCell(e.data.data.cell);
		}
		this.save();


	}

	save() {
		$.ajax({
			type: "POST",
			url: "scrivifilepage.aspx",
			data: {
				/*__VIEWSTATE: "/wEPDwUKMTc2NjgwOTU0MQ8WAh4TVmFsaWRhdGVSZXF1ZXN0TW9kZQIBZGQRNIqmYekw8U6Vkxsd4bDkXX1tSEfEA3cDQcvLRx4xVw==",
				__VIEWSTATEGENERATOR: "17631B31",
				__EVENTVALIDATION: "/wEdAAKkPP3gWzhdnGcl4dCa9b0/+R4pD6vaXMRqYqvZxPJxUpLHox4emf4WkvhQAVX9QtAH/51HMagX+B3u99UhSP1j",*/
				__VIEWSTATE: "/wEPDwUKMTc2NjgwOTU0MQ8WAh4TVmFsaWRhdGVSZXF1ZXN0TW9kZQIBZGRj4auG3St65ReeS7fjf2Q9cuc1oDxA5uH1nRS0aJhTWQ==",
				__VIEWSTATEGENERATOR: "17631B31",
				__EVENTVALIDATION: "/wEdAAKmDUpvZrvxOSfFVmi9J2N8+R4pD6vaXMRqYqvZxPJxUkJcD19joFkgYYBxpUomHeek73pZLK8E9pVtHHGIb+vU",
				testodascrivere: JSON.stringify(this.data)
			},
			success: this.writeSuccess.bind(this)
		});

	}

	writeSuccess() {
		console.log("written")
	}

	deleteItem(item, data) {
		let a = this.data.assets;
		let tmp = new Object();
		tmp.assets = new Array();
		for (let x = 0; x < this.data.assets.length; x++) {
			if (a[x].id !== item.id) {
				tmp.assets.push(a[x]);
			}
		}
		tmp.sheets = this.data.sheets;
		this.data = tmp;

		this.clickedCell(data.cell, data.row, data.col);
		this.countItems();
	}

	addOrUpdateItem(item, data) {
		let a = this.data.assets;
		let lFound = false;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === item.id) {
				a[x] = item;
				lFound = true;
				break;
			}
		}
		if (!lFound) {
			this.data.assets.push(item);
		}
		this.clickedCell(data.cell, data.row, data.col);
		this.countItems();
	}

	countItems() {
		let p = this.data.sheets.files;
		for (let x = 0; x < p.length; x++) {
			jQuery(".js-counter-" + p[x].split(".")[0]).text(p[x].split(".")[0] + " 0");
		}


		let o = new Object();
		let a = this.data.assets;
		for (let x = 0; x < a.length; x++) {
			if (o[a[x].sheet]) {
				o[a[x].sheet] = o[a[x].sheet] + 1;
			} else {
				o[a[x].sheet] = 1;
			}
		}
		for (let prop in o) {
			jQuery(".js-counter-" + prop).text(prop + " " + o[prop]);
		}

	}

	getItemId(row, col) {
		let name = this.currentFile.split("/");
		name = name[name.length - 1];
		name = name.split(".");
		name = name[0];
		name = name + "_" + row + "_" + col;
		return name.toLowerCase();
	}

	getDetailsOf(id, row, col, lOver = false) {
		let a = this.data.assets;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				return { newItem: false, item: this.update(a[x]) };
			}
		}
		let item = new ItemIniter();
		item.id = this.getItemId(row, col)
		item.sheet = this.currentFile.split(".")[0];
		item.row = row;
		item.col = col;
		item.rownew = row;
		item.colnew = col;

		if (item.type === ItemProviders.TYPE_NONE) {
			item.type = this.getTypeFromProviders(item.sheet);
		}

		//this.data.assets.push(item);
		return { newItem: true, item: this.update(item, !lOver) };
	}

	getTypeFromProviders(sheet) {
		let a = Object.getOwnPropertyNames(ItemProviders);
		for (let x = 0; x < a.length; x++) {
			if (a[x].indexOf("_" + sheet.toUpperCase()) > 0) {
				return ItemProviders[a[x]];
			}
		}
		return ItemProviders.TYPE_NONE;

	}


	update(o, lDef = false) {
		let p = new ItemIniter();
		for (let prop in o) {
			p[prop] = o[prop];
		}
		if (p.type === ItemProviders.TYPE_NONE) {
			p.type = this.getTypeFromProviders(p.sheet);
		}


		// Valori di default
		if (lDef) {
			//console.log(p.type);
			let a = ItemProviders.DEFAULTS;
			for (let x = 0; x < a.length; x++) {
				if (a[x].types.indexOf(p.type) >= 0) {
					for (let prop in a[x].stats) {
						p[prop] = a[x].stats[prop];
					}
				}
			}

		}


		return p;
	}

	hilightCell(cell) {
		//console.log(cell.attr("data-ref"));
		let tmp = cell.attr("data-ref").split("|");
		let row = tmp[0];
		let col = tmp[1];
		let id = this.getItemId(row, col);

		let a = this.data.assets;
		let lFound = false;
		jQuery(".js-rarity", cell).removeClass("rarity-common");
		jQuery(".js-rarity", cell).removeClass("rarity-uncommon");
		jQuery(".js-rarity", cell).removeClass("rarity-rare");
		jQuery(".js-rarity", cell).removeClass("rarity-epic");
		jQuery(".js-rarity", cell).removeClass("rarity-legendary");
		jQuery(".js-rarity", cell).removeClass("rarity-unique");

		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				lFound = true;
				jQuery(".js-rarity", cell).addClass("rarity-" + a[x].rarity);
				break;
			}
		}

	}

	mouseOver(cell, row, col) {
		
		if (this.panel) {
			//console.log(this.tp.row + " "+this.tp.col + " " + row + " " + col)
			if ((this.tp.row != row) || (this.tp.col != col)) {
				let det = this.getDetailsOf(this.getItemId(row, col), row, col, true);
				if (!det.newItem) {
					this.panelCompare = jQuery("#template-paneldata").clone();
					this.panelCompare.attr("id", "pandat" + Tool.ENUM++);
					this.panelCompare.css("left", jQuery(this.panel).position().left + jQuery(this.panel).outerWidth() + 30);
					this.mc.append(this.panelCompare);

					let tp = new ToolPanel(cell, this.panelCompare, row, col, det.item, det.newItem, null, true);
					tp.init();
				}
			}
		}


	}
	mouseOut(cell, row, col) {
		if (this.panelCompare) {
			this.panelCompare.remove();
			this.panelCompare = null;
		}
	}

	showResult(but) {

		jQuery(".but-menu-selected").removeClass("but-menu-selected");
		but.addClass("but-menu-selected");
		this.mc.html("");
		if (this.panelCompare) {
			this.panelCompare.remove();
			this.panelCompare = null;
		}
		if (this.panel) {
			this.panel.remove();
			this.panel = null;
		}

		/*for (let x = 0; x < this.data.assets.length; x++) {
			console.log(this.data.assets);
		}*/
		PageCommon.showPreloader(true);
		this.loadAssets();


	}

	loadAssets() {
		let sheets = [];
		let a = this.data.assets;
		let toAdd = new Array();
		for (let x = 0; x < a.length; x++) {
			if (toAdd.indexOf(a[x].sheet) < 0) {
				toAdd.push(a[x].sheet);
			}
		}
		for (let x = 0; x < toAdd.length; x++) {
			let o = { id: toAdd[x], file: this.data.sheets.path + toAdd[x] + ".png", width: 128, height: 128 };
			sheets.push(o);
		}


		this.sprites = new SpriteSheetSlicer(this.createSmallerImage.bind(this));
		this.sprites.init(sheets);
	}

	createSmallerImage() {
		let perRow = 4;
		let a = this.data.assets;
		let h = Math.ceil(a.length / perRow);


		let canvas = jQuery("<canvas width='" + (perRow*128) + "px' height='" + (h*128) + "px'></canvas>");
		let context = canvas.get(0).getContext('2d');
		this.mc.append(canvas)


		PageCommon.showPreloader(false);
		
		let row = 0;
		let col = 0;
		let done = 0;
		for (let x = 0; x < a.length; x++) {
			let item = a[x];
			let sprite = this.sprites.getSprite(item.sheet, item.row, item.col);
			let img = new Image()
			img.src = sprite;
			img.onload = () => {
				context.drawImage(img, col * 128, row * 128, 128, 128);
				a[x].rownew = row;
				a[x].colnew = col;
				col++;
				if (col >= perRow) {
					row++;
					col = 0;
				}
				done++;
				if (done === a.length) {
					this.save();
				}
			}
		}
	}

}

Tool.ENUM = 0;

Tool.CELL_WIDTH = 128;
Tool.CELL_HEIGHT = 128;
